import { jsx as _jsx } from "react/jsx-runtime";
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { TextHighlight } from '../../common/text-highlight';
import { v4 as uuid } from 'uuid';
export const DealerLocatorSearchSuggestions = ({ search, suggestions, }) => (_jsx(CatList, { children: suggestions?.map((suggestion) => {
        return (_jsx(CatListItem, { value: suggestion, size: "sm", children: _jsx(TextHighlight, { text: suggestion, textToHighlight: search }) }, uuid()));
    }) }));
